import React from "react";
import { Chip, Tooltip } from "@mui/material";

interface ProxyApplicationStatusProps {
  status: string;
}

export const StatusChip = (props: ProxyApplicationStatusProps) => {
  if (props.status === undefined) {
    return (null)
  }

  const color = props.status === 'Active' ? 'primary' : 'error'

  return (
    <Chip label={props.status} color={color} variant="outlined" size="small" sx={{ mr: 0.25 }} />
  )
}

export const VercelChip = (props: { project: string }) => (
  <Tooltip title={`Linked to Vercel project ${props.project}`}>
    <Chip label="▲ Vercel" color="default" variant="outlined" size="small" />
  </Tooltip>
);
